import { Component, OnInit } from '@angular/core';
import { ICommandModalContext } from './ICommandModalContext';
import { FuiModal } from 'ngx-fomantic-ui';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'ps-command-modal',
  templateUrl: './command-modal.component.html',
  styleUrls: ['./command-modal.component.css']
})
export class CommandModalComponent implements OnInit {
  componentContext$: Observable<any>;
  isLoading: boolean = false;

  ngOnInit(): void {

  }
  
  constructor(public modal:FuiModal<ICommandModalContext, void>) {
    
  }

  get title() {
    return this.modal.context.title;
  }

  deny() {
    this.modal.deny(null);
  }

  get dynamicComponent() {
    return this.modal.context.component;
  }

  attemptSave() {
    this.isLoading = true;
    this.modal.context.dataSource.executeCommandByName(this.modal.context.command, this.modal.context.commandModel)
    .pipe(finalize(() => {
      this.isLoading = false;
    }))  
    .subscribe(result => {
        this.modal.approve(result as any);
      }, fail => {
        // todo
      });
  }
}


